import { AuthenticatedTemplate } from "@azure/msal-react";
import React from "react";

/** Add Route Component */
//Home Section
const DashBoard = React.lazy(() =>
  import("../components/Admin/dashboard/dashboard")
);
//Company Section
const JobForm = React.lazy(() =>
  import("../components/adminSide/createJobForm")
);

const createSurveyForm = React.lazy(() =>
  import("../components/adminSide/createSurvey")
);
const JobApproveForm = React.lazy(() =>
  import("../components/adminSide/jobApproveForm")
);
const JobDetails = React.lazy(() =>
  import("../pages/Jobs/JobDetails/JobDetails")
);

const EventDetails = React.lazy(() =>
  import("../pages/Jobs/EventDetails/EventDetails")
);
const EventSurveys = React.lazy(() =>
import("../components/Admin/Surveys/SurveyView"));

const EventSurveysReport=React.lazy(() =>
import("../components/Admin/Surveys/SurveyViewReport"));

const SurveyAnswers =  React.lazy(() =>
import("../components/Admin/Surveys/SurveyAnswers"));

const SurveyPreview =  React.lazy(() =>
import("../components/Admin/Surveys/SurveyPreview"));

const ApplicantJob = React.lazy(() => import("../pages/Applicant/index"));
const AdminJobs = React.lazy(() => import("../pages/Admin/Jobs/index"));
const AdminJob = React.lazy(() => import("../pages/Admin/Job/Index"));
const CandidateGrid = React.lazy(() =>
  import("../pages/CandidateAndCompany/CandidateGrid/CandidateGrid")
);
const ApplyForJob = React.lazy(() =>
  import("../components/Applicant/Jobs/applyForJob")
);
const ClosedJobs = React.lazy(() => import("../pages/ClosedJob/Index"));

const ClosedJobsDetails = React.lazy(() =>
  import("../pages/ClosedJob/JobDetails/Index")
);
const AdvanceJobsDetails = React.lazy(() =>
  import("../pages/AdvanceSearch/Jobs/JobDetails/Index")
);
const allApplicantStaging = React.lazy(() =>
  import("../pages/CandidateAndCompany/CandidateGrid/JobDetails/Index")
);
const applicantsAdvanceSearch = React.lazy(() =>
  import("../pages/AdvanceSearch/Applicants/Index")
);
const jobsAdvanceSearch = React.lazy(() =>
  import("../pages/AdvanceSearch/Jobs/Index")
);

const checkin = React.lazy(() =>
  import("../pages/AttendeeConfirmation/checkin")
);



const SignIn = React.lazy(() => import("../pages/ExtraPages/SignIn"));
const SignUp = React.lazy(() => import("../pages/ExtraPages/SignUp"));
const SignOut = React.lazy(() => import("../pages/ExtraPages/SignOut"));
const ResetPassword = React.lazy(() =>
  import("../pages/ExtraPages/ResetPassword")
);
const ComingSoon = React.lazy(() => import("../pages/ExtraPages/ComingSoon"));
const Error404 = React.lazy(() => import("../pages/ExtraPages/Error404"));
const SuccessWindow = React.lazy(() =>
  import("../components/common/SuccessWindow")
);

const SuccessWindowSurvey = React.lazy(() =>
  import("../components/common/SuccessWindowSurvey")
);
const SurveySuccessWindow = React.lazy(() =>
  import("../components/common/SurveySuccessWindow")
);


const SuccessWindowApproved = React.lazy(() =>
  import("../components/common/SuccessWindowApproved")
);
const SuccessWindowModify = React.lazy(() =>
import("../components/common/SuccessWindowModify")
);
const AccessDeniedWindow = React.lazy(() =>
  import("../components/common/AccessDeniedWindow")
);
// const LoginPage = React.lazy(() => import("../components/Login/LoginPage"));
const BookMarkJobPost = React.lazy(() =>
  import("../pages/Profile/BookMarkJobPost/BookMarkJobPost")
);
const BookMarkJobs = React.lazy(() =>
  import("../components/adminSide/BookMarkJobs")
);

const pendingApproval = React.lazy(() =>
  import("../components/adminSide/PendingApproval")
);


const ApplicantLog = React.lazy(() =>
  import("../components/Applicant/Jobs/applicantLogin")
);

const AttendeeLog = React.lazy(() =>
  import("../components/Applicant/Survey/SurveyLogin")
);

const Survey = React.lazy(() =>
  import("../components/Applicant/Survey/Survey")
);

const dashboardReports = React.lazy(() =>
  import("../components/Reports/dashboardReports")
);
const SuccessAppliedWindow = React.lazy(() =>
  import("../components/common/SuccessAppliedWindow")
);
const settings = React.lazy(() => import("../pages/Setting/Main/Index"));
const manageDepartments = React.lazy(() =>
  import("../pages/Setting/Manage_Departments/Index")
);
const manageJobtypes = React.lazy(() =>
  import("../pages/Setting/Manage_JobTypes/Index")
);
const manageLanguages = React.lazy(() =>
  import("../pages/Setting/Manage_Languages/Index")
);
const manageLocations = React.lazy(() =>
  import("../pages/Setting/Manage_Locations/Index")
);
const manageEducations = React.lazy(() =>
  import("../pages/Setting/Manage_Educations/Index")
);
const manageGroup = React.lazy(() =>
  import("../pages/Setting/Manage_Groups/Index")
);
const cloneJob = React.lazy(() => import("../pages/ClosedJob/CloneJob/Index"));

const modifyJob_ = React.lazy(() => import("../pages/ModifyJob/Index"));


const OTP = React.lazy(() => import("../pages/ExtraPages/OTP"));

const authRoutes = [
  { path: "/", component: ApplicantJob },
  { path: "/comingsoon", component: ComingSoon },
  { path: "/resetpassword", component: ResetPassword },
  { path: "/signout", component: SignOut },
  { path: "/signup", component: SignUp },
  { path: "/signin", component: SignIn },
  { path: "/comingsoon", component: ComingSoon },
  { path: "/resetpassword", component: ResetPassword },
  { path: "/signout", component: SignOut },
  { path: "/signup", component: SignUp },
  { path: "/signin", component: SignIn },
  { path: "/All-applicant", component: CandidateGrid },
  { path: "/events", component: ApplicantJob },
  { path: "/admin-events", component: AdminJobs },
  { path: "/admin-event", component: AdminJob },
  { path: "/closed-events", component: ClosedJobs },
  { path: "/closed-events-details", component: ClosedJobsDetails },
  { path: "/applicants-report", component: applicantsAdvanceSearch },
  { path: "/events-report", component: jobsAdvanceSearch },
  { path: "/advance-search-staging", component: AdvanceJobsDetails },
  { path: "/allapplicants-staging", component: allApplicantStaging },
  { path: "/dashboard-reports", component: dashboardReports },
  { path: "/settings", component: settings },
  { path: "/setting-Departments", component: manageDepartments },
  { path: "/setting-Jobtypes", component: manageJobtypes },
  { path: "/setting-Languages", component: manageLanguages },
  { path: "/setting-Locations", component: manageLocations },
  { path: "/setting-Educations", component: manageEducations },
  { path: "/setting-manageGroup", component: manageGroup },
  { path: "/createevent", component: JobForm },
  { path: "/createsurvey", component: createSurveyForm},
  { path: "/approveevent", component: JobApproveForm },
  { path: "/clonejob", component: cloneJob },
  { path: "/modifyJob", component: modifyJob_ },
  { path: "/dashboard", component: DashBoard },
  { path: "/bookmarkevents", component: BookMarkJobs },
  { path: "/bookmarkjobpost", component: BookMarkJobPost },
  { path: "/eventdetails", component: JobDetails },
   {path: "/EventDetail", component:EventDetails},
  { path: "/applyforevent", component: ApplyForJob },
  { path: "/applicant-log", component: ApplicantLog },
  { path:"/attendee-log", component:AttendeeLog},
  { path:"/survey", component:Survey},
  { path: "/uservalidation", component: OTP },
  { path: "/success-applied-window", component: SuccessAppliedWindow },
  { path: "/successwindow", component: SuccessWindow },
  { path: "/successwindowsurvey" ,component: SuccessWindowSurvey},
  { path:  "/surveysuccesswindow",component:SurveySuccessWindow},
  { path: "/successwindowapproved", component: SuccessWindowApproved},
  { path: "/successModify", component: SuccessWindowModify },
  { path: "/error404", component: Error404 },
  { path: "/accessdenied", component: AccessDeniedWindow },
  { path: "/checkin", component:checkin},
  { path: "/pendingApproval", component: pendingApproval},
  { path:"/EventSurveys",component:EventSurveys},
  { path:"/EventSurveysReports",component:EventSurveysReport},
  { path:"/surveyanswers", component:SurveyAnswers},
  { path:"/SurveyPreview",component: SurveyPreview}
];

export {  authRoutes };
